// extracted by mini-css-extract-plugin
export default {"content":"VerifyStep_content__8ikq-","verify":"VerifyStep_verify__-97lI","button":"VerifyStep_button__ISVyZ"};